// -----------------------------------------------------------------------------
// Scripts for header menu
// -----------------------------------------------------------------------------

$(function () {
  $('.header-menu__list .menu-item').hover(function () {
    $(this).children('.sub-menu').fadeIn(300);
  }, function () {
    $(this).children('.sub-menu').fadeOut(300);
  });
});